webpackJsonp([182150868854842],{

/***/ 1828:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin: 100px 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 50px 0 50px;\n  }\n\n  h1 {\n    margin: 50px auto;\n    text-align: center;\n  }\n"], ["\n  margin: 100px 0;\n\n  @media screen and (max-width: 768px) {\n    margin: 50px 0 50px;\n  }\n\n  h1 {\n    margin: 50px auto;\n    text-align: center;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	WHATS GOING ON HERE?
	
	React's 'dangerouslySetInnerHTML' won't execute script tags.
	So here we've hacked together a way to execute this script tag
	on the global window AFTER the component is mounted.
	
	The Regex is necessary because we don't want React to 'know' that this
	is a script tag.
	
	The script tag is 'built' after the component mounts.
	 */
	var x = "<a href='https://www.iubenda.com/privacy-policy/7788348' class='iubenda-white no-brand iub-body-embed iubenda-embed' title='Privacy Policy'>Privacy Policy</a><scr" + "ipt>(function (w,d) {var loader = function () {var s = d.createElement('script'), tag = d.getElementsByTagName('script')[0]; s.src = 'https://cdn.iubenda.com/iubenda.js'; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener('load', loader, false);}else if(w.attachEvent){w.attachEvent('onload', loader);}else{w.onload = loader;}})(window, document);</scr" + "ipt>";
	
	var extractscript = /<script>(.+)<\/script>/gi.exec(x);
	x = x.replace(extractscript[0], "");
	
	var GettingStartedPage = function (_Component) {
	  _inherits(GettingStartedPage, _Component);
	
	  function GettingStartedPage() {
	    _classCallCheck(this, GettingStartedPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  GettingStartedPage.prototype.componentDidMount = function componentDidMount() {
	    window.eval(extractscript[1]);
	  };
	
	  GettingStartedPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      GettingStartedPageContainer,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "App User Privacy Agreement"
	      ),
	      _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: x } })
	    );
	  };
	
	  return GettingStartedPage;
	}(_react.Component);
	
	var GettingStartedPageContainer = _styledComponents2.default.div(_templateObject);
	
	exports.default = GettingStartedPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-jsx-bb3ac99fd5306382f6a1.js